module.exports = __webpack_public_path__ + "img/mobile-catch-assets-02.47c86c07.png";